/* eslint-disable no-param-reassign */
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';

export default class LevelSelectBtn extends Phaser.GameObjects.Container {
  constructor(scene, btnName, value) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;

    this.isSelected = false;

    this.btnValue = value;

    this.clip = ABCyaPhaser.Images.addImage(0, 0, btnName, this);

    const numTxt = ABCyaPhaser.Text.addText(0, 0, 30, '0x515152', FontKeys._odin_roundedregular, this.btnValue.toString(), this);

    // numTxt.x = this.clip.getBounds().width / 2 - numTxt.width / 2;
    numTxt.y = numTxt.height - 18;

    this.btnShadow = ABCyaPhaser.Images.addImage(0, 0, 'select-shadow', this);
    this.btnShadow.y = this.clip.getBounds().height / 2;
    this.moveBelow(this.btnShadow, this.clip);

    this.setSize(this.clip.getBounds().width, this.clip.getBounds().height);
    this.setInteractive();
  }

  setSelected(val) {
    if (this.isSelected !== val) {
      this.isSelected = val;
      if (val === true) {
        this.bounce();
      }
      else {
        this.stopBounce();
      }
    }
  };

  bounce() {
    if (this.isSelected === true && this.scene !== null) {
      ABCyaPhaser.Tweens.addTween(this, 200, { y: this.y - 20 }, Phaser.Math.Easing.Quadratic.Out, () => {
        ABCyaPhaser.Tweens.addTween(this, 200, { y: this.y + 20 }, Phaser.Math.Easing.Quadratic.In, () => {
          this.bounce();
        });
      });

      ABCyaPhaser.Tweens.addTween(this.btnShadow, 200, { scale: .8 }, Phaser.Math.Easing.Quadratic.Out, () => {
        ABCyaPhaser.Tweens.addTween(this.btnShadow, 200, { scale: 1 }, Phaser.Math.Easing.Quadratic.In);
      });
    }
  };

  stopBounce() {
    this.btnShadow.scaleX = 1;
    this.btnShadow.scaleY = 1;
    this.y = 0;
  };
}